import { useState } from "react";
import { useRecoilState } from "recoil";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, HeaderRow, Row, Col } from "../App.styles";
import {
    Pagination,
    Refresher,
    Search,
    SidebarLayout,
    Spinner,
    withPlaceholder,
} from "../common";
import HighlightList from "../common/HighlightList";
import { DesignationItemHeader } from "./Designation.styles";
import {
    termState,
    useCreateMutation,
    useDestroyMutation,
    useInvalidateInfinity,
    highlightIdState,
    useDesignationsQuery,
} from "./Designation.state";
import DesignationItem from "./DesignationItem";
import DesignationPlaceholder from "./DesignationPlaceholder";
import { DesignationContextProvider } from "./Designation.context";
import AlertDisplay from "../common/AlertDisplay";

const DesignationComponent = () => {
    const { game_id } = useParams();
    const { t } = useTranslation();
    const [openId, setOpenId] = useState();
    const [highlightId, setHighlightId] = useRecoilState(highlightIdState);
    const [term, setTerm] = useRecoilState(termState);
    const data = useDesignationsQuery(game_id);
    const { isCreating, create } = useCreateMutation();
    const { isDeleting, destroy } = useDestroyMutation();
    const afterDestroy = useInvalidateInfinity()

    const onCreate = async () => {
        const {
            data,
        } = await create();
        const { id } = data?.designation || {};
        setOpenId(id);
        setHighlightId(id);
    };

    const search = (term) => {
        setTerm(term);
    };

    return (
        <DesignationContextProvider>
            <AlertDisplay />
            <Row data-testid="designation-item__header">
                <Col size="12" xl="9" className="col--stretch">
                    <HeaderRow className="flex-grow-1 mb-2 g-2">
                        <div className="col-12 col-lg-6 mb-2 mb-lg-0">
                            <Search className="form-control--flat form-control--flat-sm m-0" onChange={search} value={term} />
                        </div>
                        <DesignationItemHeader className="col-12 col-lg-6 mb-2 d-block d-sm-flex">
                            <Row className="flex-grow-1 g-2">
                                <Col className="col--stretch col-12 col-lg-auto">
                                    <Button data-testid="designation-item__add-new" size="lg" className="btn--flat btn--flat-sm d-block w-100" color="primary" onClick={onCreate} disabled={isCreating}>
                                        {t('Add New Designation')} {isCreating && <Spinner size="0.875rem" />}
                                    </Button>
                                </Col>
                            </Row>
                        </DesignationItemHeader>
                    </HeaderRow>
                </Col>
            </Row>
            <Row>
                <SidebarLayout
                    message={t("Configure designations or statuses that teams may acquire through game play.")}
                >
                    <ul className="list-unstyled">
                        {data && data.map((row, index) => (
                            <HighlightList key={row.id} scrollId={highlightId} id={row.id}>
                                <DesignationItem
                                    index={index}
                                    {...row}
                                    clearOpenId={() => setOpenId(undefined)}
                                    onDelete={async () => {
                                        await destroy(row.id)
                                        afterDestroy()
                                    }}
                                    isDeleting={isDeleting}
                                    openId={openId}
                                    game_id={game_id}
                                />
                            </HighlightList>
                        ))}
                    </ul>
                    {
                        data && data.length === 0
                            ? (
                                <Row>
                                    <Pagination
                                        pages={0}
                                    />
                                </Row>
                            )
                            : null
                    }
                </SidebarLayout>
            </Row>
            <Refresher />
        </DesignationContextProvider>
    );
};

export default withPlaceholder(DesignationComponent, DesignationPlaceholder);
